// src/locales/en/language.js
export const language = {
    selectLanguage: "Select Language",
    currentLanguage: "Current Language",
    english: "English",
    sinhala: "Sinhala",
    tamil: "Tamil"
}